import React from "react";

const ThemeContext = React.createContext({});

export default ThemeContext;
